import { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { NavigationContext } from "../../context/NavigationContext";
import HodOneEdit from "./hodoneedit/HodOneEdit";
import { Card, Typography, Space } from "antd";
import { Form, Select, DatePicker } from "antd";
import dayjs from "dayjs";
import { Table } from "antd";

import { Pagination } from "antd";

const { Text } = Typography;


const { Option } = Select;
const { Title } = Typography

export default function ViewTeam() {
    const { authData, backUrl } = useContext(AuthContext);
    const { navigationParams, clearNavigationParams } = useContext(NavigationContext);
    const [requisitions, setRequisitions] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const [allDepartmentNames, setAllDepartmentNames] = useState([]);

    const [designationNames, setDesignationNames] = useState([]);
    const [allDesignationNames, setAllDesignationNames] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [next, setNext] = useState(null);
    const [prev, setPrev] = useState(null);
    const [particular, setParticular] = useState({ status: false, data: "" });

    // Target row to highlight (from notification)
    const [targetMrfId, setTargetMrfId] = useState(null);
    const highlightRowRef = useRef(null);

    const [filters, setFilters] = useState({
        organization: '',
        department: '',
        submission_date_after: '',
        submission_date_before: '',
        status: '',
        designation: ''
    });



    const [selectedStatus, setSelectedStatus] = useState("submitted");

    const BASE_URL = backUrl;

    const fetchRequisitions = async (page = 1, customFilters = filters) => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("approval_status", "submitted");

        if (customFilters.department) params.append("department", customFilters.department);
        if (customFilters.organization) params.append("organisation", customFilters.organization);
        if (customFilters.status) params.append("status", customFilters.status);
        if (customFilters.submission_date_after && customFilters.submission_date_before) {
            params.append("submission_date_after", customFilters.submission_date_after);
            params.append("submission_date_before", customFilters.submission_date_before);
        }
        if (customFilters.designation) params.append("designation", customFilters.designation);

        const apiUrl = `${backUrl}/api/emp/manpowerrequisitions/manager_view/?${params.toString()}`;

        try {
            const res = await axios.get(apiUrl, {
                headers: { Authorization: `Bearer ${authData?.access}` }
            });

            setRequisitions(res.data.results);
            setNext(res.data.next);
            setPrev(res.data.previous);
            setCurrentPage(page);
        } catch (err) {
            console.error("Error fetching requisitions:", err);
            setError("Failed to load requisitions");
        } finally {
            setLoading(false);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/organisations/`);
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/?organisation=${v}`);
            setDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async (departmentId) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/?department=${departmentId}`);
            setDesignationNames(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    const fetchAllDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setAllDesignationNames(res.data.results);
        } catch (err) {
            console.error("Error fetching all designations", err);
        }
    };

    const fetchAllDepartments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/`);
            setAllDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    useEffect(() => {
        if (authData?.access) {
            fetchRequisitions(1);
            // fetchDepartments();
            fetchOrganizations();
            fetchAllDesignations();
            fetchAllDepartments();
        }
    }, [authData]);

    useEffect(() => {
        fetchRequisitions(1);
    }, [filters]);

    // ✅ Handle navigation from notifications - highlight specific MRF row
    useEffect(() => {
        if (navigationParams?.mrfId && navigationParams?.openModal) {
            console.log("🎯 ViewTeam: Received navigation params:", navigationParams);
            const mrfId = navigationParams.mrfId;
            setTargetMrfId(mrfId);
            
            // Optionally auto-open the detail view
            // setParticular({ status: true, data: mrfId });
            
            clearNavigationParams();
        }
    }, [navigationParams, clearNavigationParams]);

    // ✅ Scroll to highlighted row after requisitions load
    useEffect(() => {
        if (targetMrfId && requisitions.length > 0) {
            const found = requisitions.find((r) => r.mrf_number === targetMrfId);
            if (found) {
                console.log("🎯 ViewTeam: Found target MRF:", found);
                setTimeout(() => {
                    if (highlightRowRef.current) {
                        highlightRowRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                }, 300);
            }
        }
    }, [targetMrfId, requisitions]);

    const getDepartmentName = (id) => allDepartmentNames.find((d) => d.id === id)?.name || "N/A";
    const getAllDesignationTitle = (id) => allDesignationNames.find((d) => d.id === id)?.name || "N/A";
    const getOrganizationName = (id) => organizationNames.find((o) => o.id === id)?.name || "N/A";

    const handleClickOne = (mrfno) => {
        setParticular({ status: true, data: mrfno });
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "Rejected":
                return "red-view";
            case "Sanctioned":
                return "green-view";
            default:
                return "gray-view";
        }
    };

    const columns = [
        {
            title: "MRF Number",
            dataIndex: "mrf_number",
            key: "mrf_number",
            render: (text, record) => (
                <a onClick={() => handleClickOne(record.mrf_number)}>{text}</a>
            ),
            fixed: "left",
        },
        {
            title: "Created by",
            key: "submitted_by_display",
            render: (text, record) => (
                `${record.submitted_by_display || ''} ${record.submitted_by_last_name || ''}`
            ),
        },

        {
            title: "Organization",
            dataIndex: "organisation",
            key: "organisation",
            render: (id) => getOrganizationName(id),
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
            render: (id) => getDepartmentName(id),
        },
        {
            title: "Designation",
            dataIndex: "designation",
            key: "designation",
            render: (ids) => getAllDesignationTitle(ids),
        },
        {
            title: "Vacancies",
            dataIndex: "no_of_vacancies",
            key: "no_of_vacancies",
        },
        ...(selectedStatus === "approved"
            ? [
                {
                    title: "HOD-Status",
                    dataIndex: "manager_approved",
                    key: "manager_approved",
                    render: (val) => (
                        <span className={val === 1 ? "green-view" : "red-view"}>
                            {val === 1 ? "Approved" : "Rejected"}
                        </span>
                    ),
                },
                {
                    title: "HR-Status",
                    dataIndex: "status",
                    key: "status",
                    render: (val) => {
                        const displayVal = val === "Manager_Approved" ? "Pending" : val;
                        return <span className={getStatusClass(val)}>{displayVal}</span>;
                    },
                }
            ]
            : [
                {
                    title: "Status",
                    dataIndex: "status",
                    key: "status",
                    render: (val) => <span className={getStatusClass(val)}>{val === "Not-Approved" ? "Rejected" : val}</span>,
                },
            ]),
        {
            title: "Date",
            dataIndex: "submission_date",
            key: "submission_date",
        },
    ];

    return (
        <div className="container mt-4">

            {particular.status === false ? (
                <>
                    <center><h5 className="mb-4">Team Requisitions</h5></center>

                    <div className="count-area">
                        <Card
                            hoverable
                            onClick={async () => {
                                setSelectedStatus("submitted");
                                const res = await axios.get(
                                    `${backUrl}/api/emp/manpowerrequisitions/manager_view/?approval_status=submitted`,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${authData?.access}`,
                                        },
                                    }
                                );
                                setRequisitions(res.data.results);
                            }}
                            bodyStyle={{ padding: "6px" }}
                            style={{
                                width: 120,
                                textAlign: "center",
                                borderRadius: "6px",
                                border:
                                    selectedStatus === "submitted"
                                        ? "2px solid #1677ff"
                                        : "1px solid #d9d9d9",
                                background:
                                    selectedStatus === "submitted" ? "#e6f4ff" : "#fff",
                                cursor: "pointer",
                                padding: "0px",
                            }}
                        >
                            <Title level={5} style={{ margin: 0, fontSize: "14px" }}>
                                Pending
                            </Title>
                        </Card>

                        <Card
                            hoverable
                            onClick={async () => {
                                setSelectedStatus("approved");
                                const res = await axios.get(
                                    `${backUrl}/api/emp/manpowerrequisitions/manager_view/?approval_status=approved`,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${authData?.access}`,
                                        },
                                    }
                                );
                                setRequisitions(res.data.results);
                            }}
                            bodyStyle={{ padding: "6px" }}
                            style={{
                                width: 120,
                                textAlign: "center",
                                borderRadius: "6px",
                                border:
                                    selectedStatus === "approved"
                                        ? "2px solid #52c41a"
                                        : "1px solid #d9d9d9",
                                background:
                                    selectedStatus === "approved" ? "#f6ffed" : "#fff",
                                cursor: "pointer",
                                padding: "0px",
                            }}
                        >
                            <Title level={5} style={{ margin: 0 }}>
                                Approved
                            </Title>
                        </Card>
                        <Card
                            hoverable
                            onClick={async () => {
                                setSelectedStatus("rejected");
                                const res = await axios.get(
                                    `${backUrl}/api/emp/manpowerrequisitions/manager_view/?approval_status=rejected`,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${authData?.access}`,
                                        },
                                    }
                                );
                                setRequisitions(res.data.results);
                            }}
                            bodyStyle={{ padding: "6px" }}
                            style={{
                                width: 120,
                                textAlign: "center",
                                borderRadius: "6px",
                                border:
                                    selectedStatus === "rejected"
                                        ? "2px solid #de2b2bff"
                                        : "1px solid #d9d9d9",
                                background:
                                    selectedStatus === "rejected" ? "#ef333391" : "#fff",
                                cursor: "pointer",
                                padding: "0px",
                            }}
                        >
                            <Title level={5} style={{ margin: 0 }}>
                                Rejected
                            </Title>
                        </Card>
                    </div>

                    <center>
                        <div className="filters-area" >
                            <Form.Item label="Organization" style={{ marginBottom: 12 }}>
                                <Select
                                    value={filters.organization}
                                    onChange={(value) => {
                                        setFilters({ ...filters, organization: value })
                                        fetchDepartments(value)
                                    }}
                                    placeholder="-- Select Organization --"
                                    allowClear
                                    style={{ width: '200px' }}
                                >
                                    <Option>--Select Option--</Option>
                                    {organizationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Department" style={{ marginBottom: 12 }}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={filters.department}
                                    onChange={(value) => {
                                        setFilters({ ...filters, department: value });
                                        fetchDesignations(value);
                                    }}
                                    placeholder="-- Select Department --"
                                    allowClear
                                    style={{ width: '200px' }}
                                >
                                    <Option>--Select Option--</Option>
                                    {departmentNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Designation" style={{ marginBottom: 12 }}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={filters.designation}
                                    onChange={(value) => setFilters({ ...filters, designation: value })}
                                    placeholder="-- Select Designation --"
                                    allowClear
                                    style={{ width: '200px' }}
                                >
                                    <Option>--Select Option--</Option>
                                    {designationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Submission From" style={{ marginBottom: 12 }}>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filters.submission_date_after ? dayjs(filters.submission_date_after) : null}
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_after: dateString })
                                    }
                                    placeholder="Select date"
                                />
                            </Form.Item>

                            <Form.Item label="Submission To" style={{ marginBottom: 12 }}>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filters.submission_date_before ? dayjs(filters.submission_date_before) : null}
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_before: dateString })
                                    }
                                    placeholder="Select date"
                                />
                            </Form.Item>
                            {
                                selectedStatus === "approved" && (
                                    <Form.Item label="HR Status" style={{ marginBottom: 12 }}>
                                        <Select
                                            value={filters.status}
                                            onChange={(value) => setFilters({ ...filters, status: value })}
                                            placeholder="-- Select Status --"
                                            allowClear
                                        >
                                            <Option value="Sanctioned">Sanctioned</Option>
                                            <Option value="Rejected">Rejected</Option>
                                        </Select>
                                    </Form.Item>
                                )
                            }
                        </div>
                    </center>


                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={requisitions.length > 0 ? requisitions : []}
                                    rowKey={(record) => record.id || Math.random()}
                                    bordered
                                    pagination={false}
                                    scroll={{ x: "max-content" }}
                                    style={{ marginTop: 16 }}
                                    locale={{
                                        emptyText: <Text type="secondary">No requisitions found.</Text>,
                                    }}
                                    rowClassName={(record) => {
                                        return record.mrf_number === targetMrfId ? "highlighted-row" : "custom-table-row";
                                    }}
                                    onRow={(record) => {
                                        return {
                                            ref: record.mrf_number === targetMrfId ? highlightRowRef : null,
                                        };
                                    }}
                                    components={{
                                        header: {
                                            cell: (props) => <th {...props} style={{ backgroundColor: "#0e497b", color: "#fff" }} />,
                                        },
                                    }}
                                />
                            </div>

                            <nav style={{ marginTop: "30px", marginBottom: "40px" }}>
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${!prev ? "disabled px-3" : "px-3"}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => prev && fetchRequisitions(currentPage - 1)}
                                        >Previous</button>
                                    </li>
                                    <li className="page-item disabled">
                                        <span className="page-link">Page {currentPage}</span>
                                    </li>
                                    <li className={`page-item ${!next ? "disabled px-3" : "px-3"}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => next && fetchRequisitions(currentPage + 1)}
                                        >Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </>
                    )}
                </>
            ) : (
                <HodOneEdit data={particular.data} />
            )}
        </div>
    );
}
